import { createInstance, type i18n as I18nInstance, type Resource } from 'i18next'
import resourcesToBackend from 'i18next-resources-to-backend'
import { initReactI18next } from 'react-i18next/initReactI18next'

import i18nConfig from '@/i18nConfig'
import { $Tuple } from '@/types'
import Resources from '~/@types/resources'

type InitTranslationsResult = {
  i18n: I18nInstance
  resources: Record<string, Resource>
  t: I18nInstance['t']
}

export default async function initTranslations(
  locale: string,
  namespaces: keyof Resources | $Tuple<keyof Resources>,
  i18nInstance?: I18nInstance,
  resources?: Record<string, Resource>
): Promise<InitTranslationsResult> {
  i18nInstance = i18nInstance || createInstance()

  i18nInstance.use(initReactI18next)

  if (!resources) {
    i18nInstance.use(
      resourcesToBackend((language: string, namespace: string) => import(`@/locales/${language}/${namespace}.json`))
    )
  }

  await i18nInstance.init({
    lng: locale,
    resources,
    fallbackLng: i18nConfig.defaultLocale,
    supportedLngs: i18nConfig.locales,
    defaultNS: namespaces[0] as string,
    fallbackNS: namespaces[0] as string,
    ns: namespaces as string[],
    preload: resources ? [] : i18nConfig.locales,
  })

  return {
    i18n: i18nInstance,
    resources: i18nInstance.services.resourceStore.data as Record<string, Resource>,
    t: i18nInstance.t.bind(i18nInstance),
  }
}
